<template>
  <v-autocomplete
    v-model="relatorioSelecionado"
    label="Selecione o tipo de relatório"
    :items="items"
    item-text="descricao"
    item-value="id"
    v-bind="$attrs"
    auto-select-first
    return-object
  />
</template>

<script>
import $axios from './../../../../../api/api.js'

export default {
  name: "RelatoriosAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: [Object],
    exibir_todos_relatorios: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    items() {
      if (!this.exibir_todos_relatorios) {
        return [
          {
            id: 1,
            descricao: 'Exportação Winthor',
            url: `${$axios.defaults.baseURL}/pedidos-compra-departamentos/gerar-exportacoes-winthor`
          }
        ];
      }

      return [
        {
          id: 0,
          descricao: 'Cotação em Excel',
          url: `${$axios.defaults.baseURL}/pedidos-compra-departamentos/gerar-cotacao-fornecedores`
        },
        {
          id: 1,
          descricao: 'Exportação Winthor',
          url: `${$axios.defaults.baseURL}/pedidos-compra-departamentos/gerar-exportacoes-winthor`
        }
      ]
    },
    relatorioSelecionado: {
      get: function () {
        return this.modelValue;
      },
      set: function (value) {
        this.$emit("update:modelValue", value);
      }
    }
  },
  mounted() {
    this.relatorioSelecionado = this.items[0] || {};
  }
}
</script>

<style scoped>

</style>
